import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useApi from "../../CustomHooks/useApi";
import { insurancesViewAPI } from "../../../api/apiClient";
import LoadingOverlay from "../../../LoadingOverlay";
import "../../../css/Views/InsurancesView.css";
import VariantInsurancesView from "./VariantInsurancesView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";

const InsurancesView = () => {
  const [variants, setVariants] = useState([]);
  const { callApi, isLoading } = useApi();
  const { viewGuid, variantGuid } = useParams();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

const handleRefreshClick = () => {
  setRefreshTrigger(prev => prev + 1);
};
  const navigate = useNavigate();

  useEffect(() => {
    if (!variantGuid) {
      callApi(insurancesViewAPI.getInternationalVariants, setVariants);
    }
  }, [variantGuid, refreshTrigger]);

  if (variantGuid) {
    return <VariantInsurancesView variantGuid={variantGuid} />;
  }

  return (
    <div className="insurances-view">
      <div className="insurances-container">
      {isLoading && <LoadingOverlay isLoading={true} />}
        <div className="insurance-header-section">
            <div className="insurance-header">
              Ubezpieczenia
              <FontAwesomeIcon
                icon={faSyncAlt}
                className="refresh-icon"
                onClick={handleRefreshClick}
                title="Odśwież widok"
              />
            </div>
          </div>
      
      {!isLoading && variants.length === 0 ? (
        <p>Brak wycieczek do wyświetlenia.</p>
      ) : (
        <div className="variants-grid">
          {variants.map((v) => (
            <div
              key={v.guid}
              className="variant-card fancy"
              onClick={() =>
                navigate(`/views/${viewGuid}/${v.guid}`, {
                  state: {
                    tripName: v.tripName,
                    variantName: v.variantName,
                  },
                })
              }
            >
              {v.thumbnailLink && (
                <img
                  src={v.thumbnailLink}
                  alt="Miniaturka"
                  className="variant-thumbnail"
                />
              )}
              <div className="variant-content">
                <h3 className="variant-title">{v.tripName}</h3>
                <p className="variant-subtitle">{v.variantName}</p>
                <p className="variant-dates">
                  {new Date(v.startDate).toLocaleDateString("pl-PL")} –{" "}
                  {new Date(v.endDate).toLocaleDateString("pl-PL")}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
      </div>
    </div>
  );
};

export default InsurancesView;
